module.exports = __webpack_public_path__ + "img/服务项目.89329104.png";